export const validator = require('validator');

export const errorMessages = {
  firstname: 'First Name is required',
  lastname: 'Last Name is required',
  email: 'Email Address is not valid',
  email_required: 'Email Address is required',
  postal_code: 'Postal Code is not valid',
  postal_code_required: 'Postal Code is required',
  repeat_password: 'Passwords do not match',
  swag_address_1: 'Address is required',
  swag_city: 'City is required',
  swag_postal: 'Postal code is not valid',
  swag_postal_required: 'Postal code is required',
  swag_guests: 'Guests number is required',
  food1_required: 'Food is required',
  food1_exceeded: 'Food has exceeded the character limit',
  food2_required: 'Food or Drink is required',
  food2_exceeded: 'Food or Drink has exceeded the character limit',
  topic_required: 'Topic is required',
  topic_exceeded: 'Topic has exceeded the character limit',
  address_1_required: 'Address is required',
  city_required: 'City is required',
  province_required: 'Province is required',
  social_handle_required: 'At least one social media handle is required',
  invitation_date_required: 'Invitation date is required',
  invitation_start_time_required: 'Invitation start time is required',
  invitation_message_required: 'Invitation message is required',
  invitation_start_time_invalid: 'Invitation start time is invalid',
  invitation_end_time_invalid: 'Invitation end time is invalid',
}
